"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Title = exports.SubHeadline = exports.Preamble = exports.Paragraph = exports.PageTitle = exports.ImagePageTitle = exports.Headline = void 0;
var _TypographyFactory = _interopRequireDefault(require("./TypographyFactory"));
var _Link = _interopRequireDefault(require("./Link"));
exports.Link = _Link.default;
var ImagePageTitle = exports.ImagePageTitle = (0, _TypographyFactory.default)('h1', 'imagePageTitle');
var PageTitle = exports.PageTitle = (0, _TypographyFactory.default)('h1', 'pageTitle');
var Headline = exports.Headline = (0, _TypographyFactory.default)('h2', 'headline');
var SubHeadline = exports.SubHeadline = (0, _TypographyFactory.default)('h3', 'subHeadline');
var Title = exports.Title = (0, _TypographyFactory.default)('h4', 'title');
var Preamble = exports.Preamble = (0, _TypographyFactory.default)('p', 'preamble');
var Paragraph = exports.Paragraph = (0, _TypographyFactory.default)('p', 'paragraph');